"use strict";
/**
 * The tap pads' API (ai/TAP_PAD_PLAN.md; NBA: ai/nba/N8-taps/PLAN.md): the server clock, and
 * storing and listing taps, for every tap league. Owner-only like the rest of /win-prob. Nothing
 * here is on the order path.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchServerClock = fetchServerClock;
exports.postTaps = postTaps;
exports.fetchAllTaps = fetchAllTaps;
exports.fetchTaps = fetchTaps;
const request_1 = require("./request");
/** Server time, for the pads' clock sync. */
async function fetchServerClock() {
    const response = await (0, request_1.apiRequest)("GET", "/win-prob/clock");
    return response.data.serverMs;
}
/** Send a batch of taps. */
async function postTaps(league, gameId, taps) {
    const response = await (0, request_1.apiRequest)("POST", `/win-prob/games/${encodeURIComponent(league)}/${encodeURIComponent(gameId)}/taps`, { body: { taps } });
    return response.data;
}
/**
 * One page of the game's published record after `afterSeq`, ascending (NBA only). Throws on an
 * answer that is not a page, so the loader retries rather than folds it.
 */
async function fetchAllTaps(league, gameId, afterSeq) {
    const response = await (0, request_1.apiRequest)("GET", `/win-prob/games/${encodeURIComponent(league)}/${encodeURIComponent(gameId)}/taps`, { params: { all: "1", afterSeq: String(afterSeq) } });
    const page = response.data;
    if (!page || !Array.isArray(page.rows) || typeof page.complete !== "boolean" || typeof page.nextAfterSeq !== "number") {
        throw new Error("not a record page");
    }
    return page;
}
/** The latest stored taps for a game, newest first. */
async function fetchTaps(league, gameId, limit = 200) {
    const response = await (0, request_1.apiRequest)("GET", `/win-prob/games/${encodeURIComponent(league)}/${encodeURIComponent(gameId)}/taps`, { params: { limit: String(limit) } });
    return response.data ?? [];
}
